import i18next from 'i18next'

const getByLanguage = (jaLink: string, otherLink?: string) => {
  switch (i18next.language) {
    case 'ja':
      return jaLink
    default:
      return otherLink ?? jaLink
  }
}

export const EXTERNAL_PATH = {
  DOWNLOAD_LINK_IOS: 'https://apps.apple.com/app/id1490387554',
  DOWNLOAD_LINK_ANDROID:
    'https://play.google.com/store/apps/details?id=jp.nanameue.yay',

  TWITTER: `https://twitter.com/${window?.gon?.setting?.twitter_official_account_id}`,
  LINE: 'https://line.me/R/ti/p/%40zwn0406m',

  NANAMEUE: () =>
    getByLanguage('https://nanameue.jp', 'https://nanameue.jp/en'),

  LANDING_PAGE: () =>
    getByLanguage('https://portal.yay.space/ja', 'https://portal.yay.space'),
  LANDING_PAGE_GRANTS: () =>
    getByLanguage(
      'https://portal.yay.space/ja/grants',
      'https://portal.yay.space/grants'
    ),

  YAY_SECURITY: 'https://nanameue.jp/files/yay-security-202001.pdf',

  SUPPORT: () =>
    getByLanguage(
      'https://support.yay.space/hc/ja',
      'https://support.yay.space/hc/en-us'
    ),
  TERM: () =>
    getByLanguage(
      'https://support.yay.space/hc/ja/articles/4406881133583',
      'https://support.yay.space/hc/en-us/articles/4406881133583'
    ),
  POLICY: () =>
    getByLanguage(
      'https://support.yay.space/hc/ja/articles/4406888129935',
      'https://support.yay.space/hc/en-us/articles/4406888129935'
    ),
  SPECIFIED_COMMERCIAL: () =>
    getByLanguage(
      'https://support.yay.space/hc/ja/articles/4406881137807',
      'https://support.yay.space/hc/en-us/articles/4406881137807'
    ),
  GROUP_PERMISSION: () =>
    getByLanguage(
      'https://support.yay.space/hc/ja/articles/4406881825935',
      'https://support.yay.space/hc/en-us/articles/4406881825935'
    ),
  FAQ: () =>
    getByLanguage(
      'https://support.yay.space/hc/ja/categories/4408249766927',
      'https://support.yay.space/hc/en-us/categories/4408249766927'
    ),
  TWO_FA: () =>
    getByLanguage(
      'https://support.yay.space/hc/ja/articles/9919126066575',
      'https://support.yay.space/hc/en-us/articles/9919126066575'
    ),
  MAGAZINE: () =>
    getByLanguage(
      'https://magazine.yay.space',
      'https://magazine.yay.space/en'
    ),

  RELEASE_NOTES: () =>
    getByLanguage(
      'https://magazine.yay.space/category/releasenote',
      'https://magazine.yay.space/en/category/releasenote_en'
    ),

  BASIC_RULE: () =>
    getByLanguage(
      'https://support.yay.space/hc/ja/articles/4408910008719',
      'https://support.yay.space/hc/en-us/articles/4408910008719'
    ),

  WORD: () =>
    getByLanguage(
      'https://support.yay.space/hc/ja/categories/4408532338831',
      'https://support.yay.space/hc/en-us/categories/4408532338831'
    ),

  PHONE_VERIFICATION_HELP: () =>
    getByLanguage(
      'https://support.yay.space/hc/ja/articles/4411999993743',
      'https://support.yay.space/hc/en-us/articles/4411999993743'
    ),

  BILLING_HELP: () =>
    getByLanguage(
      'https://support.yay.space/hc/ja/articles/4406881184143',
      'https://support.yay.space/hc/en-us/articles/4406881184143'
    ),

  CHAT_AGE_LIMIT_HELP: () =>
    getByLanguage(
      'https://support.yay.space/hc/ja/articles/4406881897103',
      'https://support.yay.space/hc/en-us/articles/4406881897103'
    ),
  EMPL_INFO: () =>
    getByLanguage(
      'https://support.yay.space/hc/ja/articles/12853917788559-EMPL2-0',
      'https://support.yay.space/hc/en-us/articles/12853917788559-EMPL2-0'
    ),
}
